import { useEffect, useState, useCallback } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import axios from "axios";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import SampleCarousel from "@/components/SampleCarousel";
import Marquee from "@/components/Marquee";
import Samples from "@/components/Samples";
import Occasions from "@/components/Occasions";
import HowItWorks from "@/components/HowItWorks";
import Comparison from "@/components/Comparison";
import Testimonials from "@/components/Testimonials";
import Faq from "@/components/Faq";
import FinalCta from "@/components/FinalCta";
import Footer from "@/components/Footer";
import OrderPopup from "@/components/OrderPopup";
import PaymentReturn from "@/components/PaymentReturn";
import TrackPage from "@/components/TrackPage";
import LegalPage from "@/components/LegalPage";
import NotFound from "@/components/NotFound";
import AdminPage from "@/components/admin/AdminPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function Landing() {
  const [orderOpen, setOrderOpen] = useState(false);
  const [prefill, setPrefill] = useState({});
  const [content, setContent] = useState(null);
  const [formConfig, setFormConfig] = useState(null);

  const openOrder = useCallback((data = {}) => {
    setPrefill(data);
    setOrderOpen(true);
  }, []);

  useEffect(() => {
    axios.get(`${API}/content`).then((r) => setContent(r.data)).catch(() => {});
    axios.get(`${API}/form-config`).then((r) => setFormConfig(r.data)).catch(() => {});
  }, []);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <>
      <Navbar content={content} onOrder={() => openOrder()} />
      <main>
        <Hero content={content} onOrder={openOrder} />
        <SampleCarousel content={content} />
        <Marquee content={content} />
        <Occasions content={content} onOrder={openOrder} />
        <HowItWorks content={content} />
        <Samples content={content} />
        <Comparison content={content} />
        <Testimonials content={content} />
        <Faq content={content} />
        <FinalCta content={content} onOrder={() => openOrder()} />
      </main>
      <Footer content={content} />
      <OrderPopup open={orderOpen} onClose={() => setOrderOpen(false)} prefill={prefill} content={content} formConfig={formConfig} />
    </>
  );
}

export default function App() {
  return (
    <div className="min-h-screen bg-cream text-ink font-sans overflow-x-clip" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/payment/return" element={<PaymentReturn />} />
          <Route path="/track/:orderId" element={<TrackPage />} />
          <Route path="/track" element={<TrackPage />} />
          <Route path="/legal/:slug" element={<LegalPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}
